import { GetterTree } from 'vuex';
import { IAIJobTrackerState } from './ai-job-tracker-states.store';

const getters: GetterTree<IAIJobTrackerState, {}> = <GetterTree<IAIJobTrackerState, {}>>{
    aiJobTrackerGroups: (state: IAIJobTrackerState) => state.groups,
    aiImageSessions: (state: IAIJobTrackerState) => state.sessions
};

export default getters;
